var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Gesch\xC3\xA4ftspraxis",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38095 0.549438C1.06599 0.549438 0 1.61543 0 2.93039V25.5494C0 39.3566 11.1929 50.5494 25 50.5494C38.8071 50.5494 50 39.3566 50 25.5494C50 11.7423 38.8071 0.549438 25 0.549438H2.38095ZM15.4796 19.9613L23.6543 14.153C24.011 13.8996 24.489 13.8996 24.8457 14.153L33.0204 19.9613C33.6195 20.387 33.8851 21.1442 33.6832 21.8509C32.3832 26.4009 30.0369 30.5837 26.8318 34.0651L24.6283 36.4585C24.4246 36.6798 24.0754 36.6798 23.8717 36.4585L21.6682 34.0651C18.4631 30.5837 16.1168 26.4009 14.8168 21.8509C14.6149 21.1442 14.8805 20.387 15.4796 19.9613ZM29.7639 21.3854L27.4185 18.4936C27.2589 18.2968 26.941 18.4251 26.9626 18.6775L27.2574 22.1194C27.3245 22.9029 27.2672 23.6921 27.0877 24.4578L25.6255 30.6932C25.5545 30.9961 25.9822 31.1412 26.1102 30.8577L27.5924 27.574L29.9025 22.4563C30.0625 22.1018 30.0089 21.6874 29.7639 21.3854Z",
    fill: "#F3F0E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolShield);
export default __webpack_public_path__ + "static/media/symbol-shield.edd3ae3ce8396a2d036663a1a90cc5c9.svg";
export { ForwardRef as ReactComponent };